import styled, { css } from 'styled-components';


export const FlexWrapperCenter = styled.div`
    display:flex;    
    justify-content:center;
`;

export const FlexWrapperCenterForDialog = styled.div`
    display:flex;    
    justify-content:center;
    padding: 20px;
`;

export const FlexWrapperCenterForProfile = styled.div`
    display:flex;    
    justify-content:flex-start;
    gap: 16px;
`;

export const ParentDiv = styled.div`
    width:1072px;
`;

export const FlexWrapper = styled.div`
    display:flex;
`;

export const WrapperCenter = styled.div`
    margin:'auto';
`;

export const HeaderWrapper = styled(FlexWrapper)`
    height: 55px;  
    padding: 0 30px 0 30px;
    border-radius: 27.5px;
    background-color: #f8f8fa;
    align-items:center;
    ${props => props.width && css`
        width:${props.width}
    `}
`;

export const GapView = styled.div`
    ${props => props.width && css`
        width:${props.width}
    `}
    ${props => props.height && css`
        height:${props.height}
    `}
`;

export const LineView = styled.div`      
  height: 1px;
  background:#efefef;
  ${props => props.width && css`
    width:${props.width}
  `}
`;